import React, { useEffect, useState, useContext } from "react";
import JournalTimeline from "./JournalTimeline";
import JournalInfo from "./JournalInfo";
import { GET } from "../../../../../utils/fetchUtil";
import Tabs from "../../../../../common/tabs/Tabs";
import Tab from "../../../../../common/tabs/Tab";
import { useTranslation } from "react-i18next";
import { MessageContext } from "../../../../../common/message";

function Journal({ id, uid, subject, solver, statusText }) {
  const [activeTab, setActiveTab] = useState(0);
  const [doc, setDoc] = useState([]);
  const [work, setWork] = useState({});
  const { t } = useTranslation();
  const message = useContext(MessageContext);

  useEffect(() => {
    GET(
      `/requests/${id}/submissions/${uid}/journal`,
      (journal) => {
        setDoc(journal.doc);
        setWork(journal.work);
      },
      (error) => {
        message.toggle({
          title: t("requests.reviewDocuments.action.save.error"),
          content: error,
          hideNo: true,
          yesLabel: t("modalMessage.okLabel"),
          onYes: () => {
            message.toggle({});
          },
        });
      }
    );
  }, [uid]);

  return (
    <div className="content">
      <div className="is-size-4">{statusText}</div>
      <div className="is-size-4">{subject}</div>
      <div className="is-size-4">{solver}</div>
      <Tabs
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabsClassName={"mt-6"}
        scrollToSection={false}
      >
        <Tab
          label={t("requests.preview.journal.timeline.tab")}
          render={() => <JournalTimeline work={work} />}
        />
        <Tab
          label={t("requests.preview.journal.info.tab")}
          render={() => <JournalInfo doc={doc} />}
        />
      </Tabs>
    </div>
  );
}

export default Journal;
